import { render, staticRenderFns } from "./CertMinTotalRule.vue?vue&type=template&id=229d3015"
import script from "./CertMinTotalRule.vue?vue&type=script&lang=js"
export * from "./CertMinTotalRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports